import { post } from "../../utils/axios-config";
import { DO_LOGIN } from "../../utils/constants";

export const doLogin = async (data: any) => await post<any, any>(DO_LOGIN, data);